import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";

const PATH = "/shopify-technical-seo";

export const Route = createFileRoute("/shopify-technical-seo")({
  head: () => buildHead({
    locale: "en",
    title: "Shopify Technical SEO Agency for DTC Brands | Shugert",
    description: "Shugert is a Shopify technical SEO agency for established DTC brands: crawl, indexation, canonicals, schema, collection architecture and migration visibility, with implementation from $3,000.",
    path: PATH,
    altPath: alternatePath(PATH, "es"),
    ogImage: "/og-default-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Shopify Technical SEO", path: PATH }]),
      serviceJsonLd({
        name: "Shopify Technical SEO Audit & Implementation",
        description: "Shugert provides technical SEO audits and code-level implementation for Shopify stores, including crawlability, indexation, canonical ownership, collection architecture, structured data, hreflang and migration redirect strategy.",
        path: PATH,
        serviceType: "Shopify Technical SEO Agency",
        minPrice: 3000,
        maxPrice: 5000,
        unit: "PROJECT",
        locale: "en",
      }),
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          { "@type": "Question", name: "What technical SEO issues are most common on Shopify stores?", acceptedAnswer: { "@type": "Answer", text: "Common issues include duplicate or low-value URL paths, canonical conflicts, weak collection architecture, Core Web Vitals constraints, broken internal links after migrations and incomplete structured data." } },
          { "@type": "Question", name: "Can you fix Shopify SEO issues caused by a theme migration?", acceptedAnswer: { "@type": "Answer", text: "Yes. We audit redirects, canonical tags, internal links, structured data, indexation and analytics before and after launch. The expected outcome still depends on redirect coverage, content parity, demand and the source site's existing signals." } },
          { "@type": "Question", name: "Do you implement structured data for Shopify?", acceptedAnswer: { "@type": "Answer", text: "Yes. We implement and validate relevant JSON-LD that matches visible content. Structured data can help search systems interpret a page but does not guarantee a rich result." } },
          { "@type": "Question", name: "How do you handle international SEO for Shopify?", acceptedAnswer: { "@type": "Answer", text: "We configure hreflang for genuine regional or language equivalents, validate canonical and alternate links and plan URL ownership around Shopify Markets and the regions the business can serve." } },
        ],
      },
      webPageJsonLd({ name: "Shopify Technical SEO Agency for DTC Brands", path: PATH, description: "Shugert provides Shopify technical SEO audits and implementation tied to URL ownership, staged changes and Search Console validation.", inLanguage: "en-US" }),
    ],
  }),
});
